export default "https://wedding.jeffreychan.xyz";